import React from "react";
import { Link } from "react-router-dom";

export default function CancelPage() {
  return (
    <div data-testid="cancel-page" className="max-w-[600px] mx-auto px-6 py-24 text-center">
      <div className="overline">Payment cancelled</div>
      <h1 className="font-serif text-4xl md:text-5xl mt-3">No worries.</h1>
      <p className="text-brand-muted mt-4">Your cart is still saved. Whenever you&apos;re ready, finish your order.</p>
      <Link to="/checkout" className="btn-primary mt-10 inline-block">Return to checkout</Link>
    </div>
  );
}
